export const OPTHINES = {
  voteName: '2023project/q3/2023enriching',
  mustSearch: 'Button',
  buttonBg: '#f4a842',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: '#D20A0A',
    inactiveBgColor: '#B50B0B',
  },
  tabs: [
    {
      tabName: '候选人',
      tabPath: '/fmxy/first',
    },
    {
      tabName: '相关新闻',
      tabPath: '/fmxy/news',
    },
  ],
};
